module.exports = __webpack_public_path__ + "img/Ingenierito.ac890ef7.png";